<script setup lang="ts">

import { onMounted, ref } from "vue";
import { formatDate } from "@library/Utilities";
import { useViewModelInstance } from "@app/MyGarage";
import { useBackButton } from "@app/Components/Utilities";

const model = await useViewModelInstance();
const vehicle = model.vehicle;
const hasRequiredProperties = ref( vehicle.hasRequiredProperties );

const hasItems = model.history.length > 0;

onMounted( () =>
{
    useBackButton( hasRequiredProperties.value );
} );

</script>

<template>
 
    <div class="bg-gray-50/70 dark:bg-gray-900
                text-base lg:text-lg
                w-full h-full overflow-y-auto overflow-x-hidden flex flex-col pb-12">
                    
        <div class="bg-gradient-to-b dark:from-gray-900 dark:to-gray-850">

            <div class="p-6 text-center">
                <h2 class="text-xl 3xl:text-2xl tracking-wider flex gap-2 justify-center items-center">
                      Vehicle History
                </h2>
                <p class="text-sm lg:text-base 3xl:text-xl pt-4 opacity-60">
                    Keeps a log of all services and maintenance work that you've
                    had done to your car
                </p>
            </div>   

            <!-- PAGE TITLE -->
            <div class="px-6 text-center">
                <div v-if="hasRequiredProperties" class="text-center">
                    <h2 class="text-xl tracking-wider">
                        {{ vehicle.displayName }}
                    </h2>
                </div>
            </div>
        </div>
                
        <div v-if="hasItems"
             class="w-full h-max table overflow-hidden
                    bg-gradient-to-b dark:from-gray-850 dark:to-gray-850">

            <div v-for="(item,index) in model.history"
                 class="px-6 py-4 last:mb-0
                        border-b border-b-white dark:border-b-gray-900
                        flex items-center"
                 :class="{'border-t border-t-white dark:border-t-gray-850': index == 0 }">
                <div>
                    <div class="3xl:text-xl">{{ item.title }}</div>
                    <div class="text-sm 3xl:text-lg opacity-50">{{ formatDate( item.utcEventDate, 'dddd, Do MMM YYYY' ) }}</div>
                </div>
            </div>

        </div>

        <!-- There is no history -->
        <div v-else class="text-base">
            There are no history items to display
        </div>

    </div>

</template>
